import React, { useEffect, useState } from 'react';
import { Alert as BootstrapAlert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ALERT_VARIANTS = ['success', 'danger', 'warning'];
const blockEl = 'ui__alert';

export const Alert = ({ className = '', color = ALERT_VARIANTS[0], isOpen = true, onClose = () => {}, children, ...props }) => {
  const [isAlertOpen, setIsAlertOpen] = useState(isOpen);
  const variant = ALERT_VARIANTS.includes(color) ? color : 'success';
  // eslint-disable-next-line no-nested-ternary
  const icon = variant === 'danger'
    ? faExclamationTriangle
    : variant === 'warning'
      ? faInfoCircle
      : faCheckCircle;

  useEffect(() => {
    setIsAlertOpen(isOpen);
  }, [isOpen]);

  const handleOnClose = () => {
    setIsAlertOpen(false);
    onClose();
  };

  return (
    <BootstrapAlert
      className={classNames(blockEl, className, `${blockEl}--${variant}`)}
      color={variant}
      isOpen={isAlertOpen}
      toggle={handleOnClose}
      {...props}
    >
      <span>
        <FontAwesomeIcon icon={icon} />
      </span>
      {children}
    </BootstrapAlert>
  );
};

Alert.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(ALERT_VARIANTS),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired
};

export default Alert;
